module.exports = __webpack_public_path__ + "static/media/mobile-bg.f65d0c03.svg";